import moment from 'moment-mini';

const SQL_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
const LOCAL_DATE_TIME_FORMAT = "MM/DD/YYYY HH:mm:ss";
export const UNIX_FORMAT = 'X';

export const sqlDateTimeToLocalDateTime = value => moment(value, SQL_DATE_TIME_FORMAT).format(LOCAL_DATE_TIME_FORMAT);

export const unixTimeToLocalDateTime = value => moment.unix(value).format(LOCAL_DATE_TIME_FORMAT);

export const getCurrentUnixTime = () => parseInt(moment().format(UNIX_FORMAT));

export const diffInSecondsFromNow = (value) => moment().diff(value, 'seconds');

export const getTimeAgo = value => moment(value).fromNow();
